const description = `The flowchart diagram is a graphical representation of a process or workflow,
where nodes represent steps or actions, and arrows indicate the flow of control or data between them.
It is useful for visualizing complex processes, decision-making paths, and sequential operations.
`;

export default description;
